
define('ldsh!modules/page_listing/templates/limit_notice', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="md__notification mb48 md__advise--' +
__e( adviseType ) +
'">\n  <div>\n    <span data-i18n="pageListing.visitsWarning"\n      data-i18n-options=\'{"percentage":"' +
__e( percentage.toFixed(2) ) +
'"}\'></span>\n    <a class="text--link" href="' +
((__t = (paymentsUrl + '/account/products?company_id=' + companyId )) == null ? '' : __t) +
'"\n      data-i18n="reminders.updateYourAccount"></a>\n  </div>\n</div>';

}
return __p
};});

